export enum ObjectTypeEnum {
	None,
	Content,
	Receiver,
	TaskPart
}

function areSameObjectType(objectType1: ObjectTypeEnum | undefined, objectType2: ObjectTypeEnum | undefined): boolean{
	if (objectType1 != undefined && objectType2 != undefined) {
		return objectType1 === objectType2;
	}
	return false;
}

export function isContentObjectType(objectType: ObjectTypeEnum | undefined): boolean {
	return areSameObjectType(objectType, ObjectTypeEnum.Content)
}

export function isTaskPartObjectType(objectType: ObjectTypeEnum | undefined): boolean {
	return areSameObjectType(objectType, ObjectTypeEnum.TaskPart)
}

export function isReceiverObjectType(objectType: ObjectTypeEnum | undefined): boolean {
	return areSameObjectType(objectType, ObjectTypeEnum.Receiver)
}